import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RawMaterialListLayer from "../components/RawMaterialListLayer";

const RawMaterialListPage = () => {
  return (
    <MasterLayout>
      <RawMaterialListLayer />
    </MasterLayout>
  );
};

export default RawMaterialListPage;
